import React, { useEffect, useState } from "react";
import { getDatabase, ref, onValue } from "firebase/database";
import app from "../../../firebaseConfig";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  Typography,
} from "@mui/material";

const ClienteCard = ({ cliente, onClick }) => {
  const [montoAnimado, setMontoAnimado] = useState(0);

  useEffect(() => {
    let start = 0;
    const target = cliente.totalGastado;
    const step = Math.ceil(target / 50); // velocidad basada en el valor
    const interval = setInterval(() => {
      start += step;
      if (start >= target) {
        setMontoAnimado(target);
        clearInterval(interval);
      } else {
        setMontoAnimado(start);
      }
    }, 20);
    return () => clearInterval(interval);
  }, [cliente.totalGastado]);

  return (
    <div
      style={{
        borderRadius: 10,
        backgroundColor: "#f0f0f0",
        marginBottom: 15,
        padding: 15,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <div style={{ flex: 1 }}>
        <strong>📧 {cliente.correo}</strong>
      </div>
      <div style={{ flex: 1, textAlign: "center" }}>
        🧾 Visitas: {cliente.visitas}
      </div>
      <div style={{ flex: 1, textAlign: "center", fontWeight: "bold" }}>
        💰 Total: ${montoAnimado.toLocaleString()}
      </div>
      <div style={{ flex: 1, textAlign: "right" }}>
        ⏱ Última: {cliente.ultimaFecha}
      </div>
    </div>
  );
};

const ResumenClientes = () => {
  const [resumenClientes, setResumenClientes] = useState([]);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [todosPedidos, setTodosPedidos] = useState([]);

  useEffect(() => {
    const db = getDatabase(app);
    const pedidosRef = ref(db, "nature/Awoo/Pedidos/Pagados");

    onValue(pedidosRef, (snapshot) => {
      const data = snapshot.val();
      const resumen = {};
      const pedidos = [];

      if (data) {
        Object.values(data).forEach((pedido) => {
          const correoRaw = pedido.correo?.toLowerCase() || "no proporcionado";
          const correo = correoRaw.trim();
          const fecha = pedido.fecha || "Sin fecha";
          let total = 0;
if (typeof pedido.totalPedido === "string") {
  total = parseFloat(pedido.totalPedido.replace(/\./g, "")) || 0;
} else if (typeof pedido.totalPedido === "number") {
  total = pedido.totalPedido;
}


          pedidos.push(pedido); // todos los pedidos

          if (correo === "no proporcionado") return; // excluir no registrados

          if (!resumen[correo]) {
            resumen[correo] = {
              correo,
              visitas: 1,
              totalGastado: total,
              ultimaFecha: fecha,
              pedidos: [pedido],
            };
          } else {
            resumen[correo].visitas += 1;
            resumen[correo].totalGastado += total;
            resumen[correo].pedidos.push(pedido);

            if (
              new Date(fecha.split("/").reverse().join("-")) >
              new Date(resumen[correo].ultimaFecha.split("/").reverse().join("-"))
            ) {
              resumen[correo].ultimaFecha = fecha;
            }
          }
        });
      }

      const clientesOrdenados = Object.values(resumen)
        .sort((a, b) => b.visitas - a.visitas)
        .slice(0, 15);

      setResumenClientes(clientesOrdenados);
      setTodosPedidos(pedidos);
    });
  }, []);

  return (
    <div style={{ padding: 20 }}>
      {/* Título blanco */}
      <h2 style={{ color: "#ffffff", fontWeight: "bold" }}>📊 Resumen de Clientes</h2>

      {/* Totales complementarios */}
      <div style={{ marginBottom: 20, marginTop: 5, fontSize: 16 }}>
        <div style={{ color: "#ffffff", fontWeight: "bold" }}>
          ✔ Total Pedidos: {todosPedidos.length}
        </div>
        <div style={{ color: "#00BFFF", fontWeight: "bold" }}>
          ✖ Pedidos No Registrados: {
            todosPedidos.filter(p => p.correo?.toLowerCase().trim() === "no proporcionado").length
          }
        </div>
      </div>

      {/* Tarjetas de clientes con animación */}
      {resumenClientes.map((cliente, index) => (
        <ClienteCard
          key={index}
          cliente={cliente}
          onClick={() => {
            setClienteSeleccionado(cliente);
            setOpenDialog(true);
          }}
        />
      ))}

      {/* Modal de pedidos por cliente */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>🧾 Pedidos de {clienteSeleccionado?.correo}</DialogTitle>
        <DialogContent dividers style={{ maxHeight: 400 }}>
          {clienteSeleccionado?.pedidos.map((pedido, idx) => (
            <div
              key={idx}
              style={{
                marginBottom: 15,
                borderBottom: "1px solid #ccc",
                paddingBottom: 10,
              }}
            >
              <Typography variant="subtitle2">
                📅 {pedido.fecha} 🕐 {pedido.hora} | 💸 Total: ${pedido.totalPedido}
              </Typography>
              <ul style={{ paddingLeft: 20 }}>
                {pedido.productos &&
                  Object.values(pedido.productos).map((p, i) => (
                    <li key={i}>
                      {p.cantidad}x {p.titulo} (${p.precioUnitario})
                    </li>
                  ))}
              </ul>
            </div>
          ))}
        </DialogContent>
        <Button onClick={() => setOpenDialog(false)}>Cerrar</Button>
      </Dialog>
    </div>
  );
};

export default ResumenClientes;
